module.exports = __webpack_public_path__ + "img/technologyModel.85a3ff59.png";